export { lexCompare } from './lex-comparator.ts';
